import React from "react";
import { Box, Image, Text } from "@chakra-ui/react";
import { useParams } from "react-router-dom";
import { allProjects } from "./ProjectData"; 

function Header() {
  const { projectName } = useParams();
  const projectData = allProjects[projectName];


  if (!projectData || !projectData.header) {
    return (
      <Box textAlign="center" mt={10}>
        <Text fontSize="2xl" color="red.500">Project Header Not Found</Text>
      </Box>
    );
  }

  const { backgroundImg, titleLine1, titleLine2 } = projectData.header;

  return (
    <Box
      position="relative"
      w="100%"
      h={{ base: '45vh', md: "100vh" }}
      backgroundColor={'rgb(0, 0, 0,0.4)'}
      display="flex"
      alignItems="center"
      justifyContent="center"
      flexDirection="column"
      overflow="hidden"
      opacity={'0.8'}
    >
      <Box position="relative" maxW={{ base: "100%", md: "650px" }} w="100%" mx="auto">
        <Image src={backgroundImg} alt="Header Background" w="100%" />
        <Box
          position="absolute"
          top="10%"
          left="7%"
          w="86%"
          h="78%"
          display="flex"
          alignItems="center"
          justifyContent="center"
          flexDirection="column"
          textAlign="center"
          zIndex={2}
        >
          <Box position="absolute" zIndex={3} color="white">
            <Text fontSize={{ base: "2xl", md: "7xl" }} fontWeight="bold" letterSpacing="wide">
              {titleLine1}
            </Text>
            <Text fontSize={{ base: "xl", md: "7xl" }} fontWeight="semibold" mt={1} letterSpacing="wider">
              {titleLine2}
            </Text>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}

export default Header;
